import React from 'react';
import { Container, Typography} from '@mui/material';

function Errors() {

  return (
    <Container sx={{
      backgroundColor: "#fff",
      minHeight: "90vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <Typography variant="h6">Oops!! Invalid URL</Typography>
    </Container>
  );
}
export default Errors;